import { LazyMotion, domAnimation, m, useScroll, useSpring } from "motion/react";
import Background from "../../components/background";
import Navbar from "../../components/navbar";
import Hero from "../../components/hero";
import BelowFold from "./below-fold";
import SmoothScroll from "../../components/shared/smooth-scroll";

const ScrollProgress = () => {
	const { scrollYProgress } = useScroll();
	const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30 });
	return (
		<m.div
			className="fixed inset-x-0 top-0 z-[70] h-px origin-left bg-gradient-to-r from-gold-dark via-gold-light to-crimson"
			style={{ scaleX }}
		/>
	);
};

// Only the animation features the site uses (no layout/drag engine), strictly enforced.
const HomePage = () => (
	<LazyMotion features={domAnimation} strict>
		<SmoothScroll />
		<Background />
		<ScrollProgress />
		<Navbar />
		{/* Clip sideways overflow (giant words, glows) without making main a scroll box, which would break the pinned scenes */}
		<main className="overflow-x-clip">
			<Hero />
			<BelowFold />
		</main>
	</LazyMotion>
);

export default HomePage;
